<template>
    <div class="page" :style="pageStyle.style">
        <div class="page-header">欢迎登录三农系统</div>
        <div class="login">
            <a-input v-model:value="account" placeholder="用户名">
                <template #prefix><UserOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
            </a-input>
            <a-input v-model:value="password" type="password" placeholder="密码">
                <template #prefix><LockOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
            </a-input>
            <p @click="retrievePWD">找回密码</p>
            <a-button @click="onSubmit" class="sub-btn">提交</a-button>
            <a-button @click="onRegister" class="reg-btn">注册</a-button>
        </div>
    </div>
</template>

<script>
import {ref, onMounted, reactive} from "@vue/runtime-dom"
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import {loginApi} from '@/api/login'
import Cookies from 'js-cookie'
import router from "@/router"
import {notification} from "ant-design-vue"
export default {
    name: "Login",
    setup() {
        const account = ref('')
        const password = ref('')
        const pageStyle = reactive({
            style: {}
        })
        const onSubmit = async () => {
            const params = {
                account: account.value,
                password: password.value,
                grantType: 'password'
            }
            const res = await loginApi(params)
            if (res) {
                Cookies.set('Token', JSON.stringify(res.token), { expires: 1 })
                Cookies.set('userInfo', JSON.stringify(res), { expires: 1 })
                notification.success({ message: '登录成功!', description: '', duration: 2 })
                setTimeout(() => {
                    router.back(-1)
                }, 2000)
            }
        }
        // const onRegister = () => {
        //     alert('未开放注册！')
        // }
        onMounted(() => {
            pageStyle.style = { height: window.innerHeight+'px', width: window.innerWidth + 'px'}
        })
        return {
            account,
            password,
            pageStyle,
            onSubmit,
            // onRegister
        }
    },
    methods: {
        onRegister() {
            router.push({name: 'DirectoryRegister'})
        },
        retrievePWD() {
            router.push({name: 'ResetPassword'})
        }
    },
    components: {
        UserOutlined,
        LockOutlined
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        background #FFF
        .page-header {
            width 100%
            height 185px
            line-height 185px
            text-align center
            color #FFF
            font-size 18px
            font-weight bolder
            letter-spacing 2px
            background-image url("../../assets/img/login_main_banner.png")
            background-size 100% 100%
            background-repeat no-repeat
            margin-bottom 10px
        }
        .login {
            width 100%
            padding 20px 35px
            .sub-btn {
                color #FFF
                background-color #00BE6E
            }
            .reg-btn {
                color #00BE6E
                background-color #FFF
            }
        }
        .login >>> .ant-input-affix-wrapper {
            margin-bottom 10px
        }
        .login p {
            color #6A6A6A
            font-size 12px
            text-align right
            margin 5px 0
        }
        .login >>> .ant-btn {
            width 100%
            border-radius 10px
            border-color #00BE6E
            margin-bottom 15px
        }
    }
</style>